export default [
  {
    path: 'minha-conta',
    name: 'account.index',
    meta: {
      title: 'Minha Conta',
      auth: true,
      RedirectIfAuthenticated: false
    },
    component: () => import(/* webpackChunkName: "account.index" */ '../views/account/index.vue')
  }
]
